import classNames from 'classnames';
import { AdUnit, AdUnitClasses } from 'googlead/components/AdUnit';
import { GPTAds } from 'googlead/GPTAds';
import { AdPositions } from 'googlead/types';
import React from 'react';
import { weSkiDestinationId } from 'components/common/PlanYourTrip/WeSki/resolver';
import { WESKI_FLEXIBLE_OPTION } from 'ots-constants';
import { getLocale } from 'i18n/locale';
import { ELocale } from 'i18n/localeEnum';
import { isResortWithoutWeSki } from 'util/isResortWithoutWeSki';
import { isRegionWithoutWeSki } from 'util/isRegionWithoutWeSki';
import styles from './adunit.module.scss';
import WeSki from '../../components/common/PlanYourTrip/WeSki/WeSkiWidget';

interface IProps {
  id?: string;
  isRegion?:boolean;
  showWeSki?: boolean;
  showWeSkiOnMobileOnly?: boolean;
  hideWeSkiOnMobile?: boolean;
}

const getWeSkiDestinationId = (id: string, isRegion:boolean) => {
  const weDestinationId = (isRegion ? weSkiDestinationId({ regionId: id }) : weSkiDestinationId({ resortId: id })) ?? WESKI_FLEXIBLE_OPTION;

  return weDestinationId;
};

export const SidebarAd = ({
  id = '',
  isRegion = false,
  showWeSki = true,
  showWeSkiOnMobileOnly = false,
  hideWeSkiOnMobile = false,
}: IProps) => {
  const locale = getLocale();
  const weSkiDestination = getWeSkiDestinationId(id, isRegion);
  const shouldHideWeSki = isResortWithoutWeSki(locale, id) || isRegionWithoutWeSki(locale, id);
  const shouldShowWeSki = showWeSki && locale !== ELocale.IT_IT && !shouldHideWeSki;

  return (
    <>
      <div className={styles.nonSticky}>
        <AdUnit
          generator={GPTAds[AdPositions.Skyscraper]}
          className={AdUnitClasses.sky}
          desktop
          mobile
          recreateOnTablet
        />
      </div>
      {shouldShowWeSki && (
        <div
          className={classNames(
            styles.sticky,
            showWeSkiOnMobileOnly && styles.mobileOnly,
            hideWeSkiOnMobile && styles.desktopOnly,
          )}
        >
          <WeSki destinationId={weSkiDestination} />
        </div>
      )}
    </>
  );
};
